/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Product_Improvement_TextInputs */

const en_consent_product_improvement_text = /** @type {(inputs: Consent_Product_Improvement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My personal data will not be shared.`)
};

const de_consent_product_improvement_text = /** @type {(inputs: Consent_Product_Improvement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine persoenlichen Daten werden dabei nicht weitergegeben.`)
};

const fr_consent_product_improvement_text = /** @type {(inputs: Consent_Product_Improvement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes donnees personnelles ne seront pas partagees.`)
};

const es_consent_product_improvement_text = /** @type {(inputs: Consent_Product_Improvement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis datos personales no seran compartidos.`)
};

const it_consent_product_improvement_text = /** @type {(inputs: Consent_Product_Improvement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I miei dati personali non saranno condivisi.`)
};

const nl_consent_product_improvement_text = /** @type {(inputs: Consent_Product_Improvement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mijn persoonlijke gegevens worden niet gedeeld.`)
};

const pl_consent_product_improvement_text = /** @type {(inputs: Consent_Product_Improvement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje dane osobowe nie beda udostepniane.`)
};

const fi_consent_product_improvement_text = /** @type {(inputs: Consent_Product_Improvement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henkilotietojani ei jaeta.`)
};

const da_consent_product_improvement_text = /** @type {(inputs: Consent_Product_Improvement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mine personlige data deles ikke.`)
};

const sv_consent_product_improvement_text = /** @type {(inputs: Consent_Product_Improvement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mina personuppgifter delas inte.`)
};

/**
* | output |
* | --- |
* | "My personal data will not be shared." |
*
* @param {Consent_Product_Improvement_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_product_improvement_text = /** @type {((inputs?: Consent_Product_Improvement_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Product_Improvement_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_product_improvement_text(inputs)
	if (locale === "fr") return fr_consent_product_improvement_text(inputs)
	if (locale === "es") return es_consent_product_improvement_text(inputs)
	if (locale === "it") return it_consent_product_improvement_text(inputs)
	if (locale === "nl") return nl_consent_product_improvement_text(inputs)
	if (locale === "pl") return pl_consent_product_improvement_text(inputs)
	if (locale === "fi") return fi_consent_product_improvement_text(inputs)
	if (locale === "da") return da_consent_product_improvement_text(inputs)
	if (locale === "sv") return sv_consent_product_improvement_text(inputs)
	return en_consent_product_improvement_text(inputs)
});